import { Row, Col, Button } from "antd";
import React, { Component } from "react";
import PlantOrder from "../../components/DashboardStatsCard/plantorder";
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import DeleteOrder from "../../assets/images/delete_order.png";

class LogisticsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logisticsfilter: {
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
      },
      isClose: false,
      isOpenModal: false,
      isOpenLogisticModal: false,
      isRejectLogisticModal: false,
      userId: "",
      isAllow: "",
    };
  }
  componentDidMount() {
    const { getLogisticPartner } = this.props;

    const companyId = this.props.user?.[1]?.platform_owner?.id;
    // const userId = this.props.user?.[2].platform_owner_user?.id;

    if (companyId) {
      getLogisticPartner(this.state.logisticsfilter);
    }
  }
  componentDidUpdate(preProps, preState) {
    const { getLogisticPartner } = this.props;

    if (preProps.logisticMetaData !== this.props.logisticMetaData) {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          page: this.props?.logisticMetaData?.current_page,
          totalCount: this.props?.logisticMetaData?.total_records,
          currentCount: this.props?.logisticMetaData?.current_records,
          total_pages: this.props?.logisticMetaData?.total_pages,
        },
      });
    }

    if (
      preState.logisticsfilter.page !== this.state.logisticsfilter.page ||
      preState.logisticsfilter.search !== this.state.logisticsfilter.search ||
      // preState.logisticsfilter.status !== this.state.logisticsfilter.status ||
      preState.logisticsfilter.start_date !==
      this.state.logisticsfilter.start_date ||
      preState.logisticsfilter.end_date !==
      this.state.logisticsfilter.end_date ||
      preState.logisticsfilter.period !== this.state.logisticsfilter.period
    ) {
      getLogisticPartner(this.state.logisticsfilter);
    }
  }
  toggleModal = () => {
    this.setState({
      isOpenModal: false,
      isOpenLogisticModal: false,
      isRejectLogisticModal: false,
    });
  };
  onChangeLogisticsTab = (key) => {
    const { getLogisticPartner } = this.props;

    if (key == "1") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          status: "",
        },
      });
      getLogisticPartner({ ...this.state.logisticsfilter, status: "" });
    }

    if (key == "2") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          status: "pending",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        status: "pending",
      });
    }
    if (key == "3") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          status: "active",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        status: "active",
      });
    }
    if (key == "4") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          status: "rejected",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        status: "rejected",
      });
    }
    if (key == "5") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          status: "inactive",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        status: "inactive",
      });
    }
    if (key == "6") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          status: "unsubscribed",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        status: "unsubscribed",
      });
    }
  };

  onCurrentPage = (e) => {
    this.setState({
      logisticsfilter: {
        ...this.state.logisticsfilter,
        page: this.state.logisticsfilter?.page + 1,
      },
    });
  };

  onPreviousPage = (e) => {
    this.setState({
      logisticsfilter: {
        ...this.state.logisticsfilter,
        page: this.state.logisticsfilter?.page - 1,
      },
    });
  };

  onChangeText = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: e.target.value,
      },
    });
  };

  onSearchLogistics = (e) => {
    this.setState({
      logisticsfilter: {
        ...this.state.logisticsfilter,
        search: e.target.value,
      },
    });
  };

  onChangeFilter = (end_date, start_date) => {
    // this.setState({
    //   filter: {
    //     ...this.state.filter,
    //     start_date,
    //     end_date,
    //   },
    // });
  };
  onChangePeriod = (period) => {
    this.setState({
      filter: {
        ...this.state.filter,
        period,
      },
    });
  };

  handleModal = () => {
    this.state.isOpenLogisticModal &&
      this.props.logisticActivation(
        this.state.userId,
        () => {
          this.toggleModal();
          this.props.getLogisticPartner(this.state.logisticsfilter);
        },
        "deactivate"
      );
    this.state.isRejectLogisticModal &&
      this.props.logisticRejection(
        this.state.userId,
        () => {
          this.toggleModal();
          this.props.getLogisticPartner(this.state.logisticsfilter);
        },
        "reject"
      );
  };
  render() {
    const { isOpenModal, isOpenLogisticModal, isRejectLogisticModal } =
      this.state;

    const logisticCol = [
      {
        title: "NAME",
        dataIndex: "",
        align: "left",
        key: "business_name",
        width: '25%',
        className: "action-class",
        sorter: (a, b) => a.business_name?.localeCompare(b.business_name),
        render: (r) => {
          return (
            <div>
              <span
                style={{ color: "#09c1b2" }}
                onClick={() =>
                  this.props.history.push({
                    pathname: `/logistics/${r.id}/orders`,
                    state: r,
                  })
                }
                className="pointer-cursor text-capitilize"
              >
                {r.business_name}
                {/* {r?.business_name.charAt(0).toUpperCase() +
                  r?.business_name.slice(1)} */}
              </span>
            </div>
          );
        },
      },
      {
        title: "DATE",
        dataIndex: "",
        align: "left",
        key: "created_at",
        width: '25%',
        className: "action-class",
        sorter: (a, b) => a.created_at.localeCompare(b.created_at),
        render: (r) => (
          <div>
            <span>{moment(r?.created_at).format("MM-DD-YYYY")}</span>
          </div>
        ),
      },
      {
        title: "STATUS",
        dataIndex: "",
        align: "left",
        key: "email",
        width: '25%',
        className: "action-class",
        sorter: (a, b) => a.email.localeCompare(b.email),
        render: (r) => (
          <div>
            <p>
              {r.status == 2
                ? "Active "
                : r.status == 3
                  ? "Inactive"
                  : r.status == 4
                    ? "Rejected"
                    : r.status == 5
                      ? "	Unsubscribed"
                      : "Pending"}
            </p>
          </div>
        ),
      },
      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        className: "action-class",
        width: '25%',
        render: (r) => (
          <div>
            <p
              className="st-primary pointer-cursor "
              onClick={() =>
                r.status == 3 || r.status == 1 || r.status == 4
                  ? this.props.logisticActivation(
                    r.id,
                    () =>
                      this.props.getLogisticPartner(
                        this.state.logisticsfilter
                      ),
                    "activate"
                  )
                  : this.setState({
                    userId: r.id,
                    isAllow: r.status,
                    isOpenLogisticModal: true,
                  })
              }
              style={{
                color:
                  r.status == 2 ? "red" : r.status == 3 ? "#26a69a" : "black",
              }}
            >
              <p>
                {r.status == 1 ? (
                  <>
                    <span
                      style={{
                        color: "#26a69a",
                        paddingRight: "5px",
                        fontSize: "12px",
                      }}
                    >
                      APPROVE
                    </span>
                    <span
                      style={{ color: "red", fontSize: "12px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({
                          userId: r.id,
                          isAllow: r.status,
                          isRejectLogisticModal: true,
                        });
                      }}
                    >
                      REJECT
                    </span>
                  </>
                ) : r.status === 2 ? (
                  <span
                    style={{ color: "#ff0404", fontSize: "12px" }}
                    className="onhover"
                  >
                    DEACTIVATE
                  </span>
                ) : r.status === 3 ? (
                  <span
                    style={{ color: "#26a69a", fontSize: "12px" }}
                    className="onhover"
                  >
                    ACTIVATE
                  </span>
                ) : r.status === 4 ? (
                  <span
                    style={{ color: "#26a69a", fontSize: "12px" }}
                    className="onhover"
                  >
                    APPROVE
                  </span>
                ) : (
                  "-"
                )}
              </p>
            </p>
          </div>
        ),
      },
    ];
    return (
      <Row justify="space-between">
        <Col span={24} style={{ marginTop: '-10px' }}>
          <PlantOrder
            {...this.props}
            inputText={"All Logistics Partners"}
            onChangeTab={this.onChangeLogisticsTab}
            metaData={this.state.logisticsfilter}
            currentPage={this.onCurrentPage}
            previousPage={this.onPreviousPage}
            onChangeText={this.onSearchLogistics}
            onChangeFilter={this.onChangeFilter}
            onChangePeriod={this.onChangePeriod}
            columns={logisticCol}
            isShowLogisticPartners={true}
            isShowPlusSign={true}
            onClearSearch={() =>
              this.setState({
                logisticsfilter: { ...this.state.logisticsfilter, search: "" },
              })
            }
            searchVal={this.state.logisticsfilter.search}
          />
        </Col>
        <CustomModal
          visible={isOpenModal || isOpenLogisticModal || isRejectLogisticModal}
          onCancelModal={this.toggleModal}
          footer={[
            <Row justify="center">
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.handleModal()}
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.toggleModal()}
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" style={{marginBottom:'20px'}}>
              <img src={DeleteOrder} />
            </Col>
            <Col>
              <p>
                {this.state.isOpenLogisticModal == true
                  ? "Are you sure you want to deactivate this logistic partner?"
                  : this.state.isRejectLogisticModal === true
                    ? "Are you sure you want to reject this logistic partner?"
                    : "Are you sure you want to deactivate this plant company?"}
              </p>
            </Col>
          </Row>
        </CustomModal>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    Orders: store.DashboardReducer.orders,
    manufacturePlants: store.DashboardReducer.manufacturePlant,
    logisticPartners: store.DashboardReducer.logisticPartner,
    user: store.AuthReducer.user,
    metaData: store.DashboardReducer.metaData,
    logisticMetaData: store.DashboardReducer.logisticmetaData,
    loading: store.DashboardReducer.isLodadingCount,
    isLoader: store.DashboardReducer.isOrder,
    isLogisticLoader: store.DashboardReducer.isLogisticLoading,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getLogisticPartner: (params) =>
      dispatch(DashboardAction.getLogisticPartnerReq(params)),
    logisticActivation: (id, cb, params) =>
      dispatch(DashboardAction.logisticsActivationReq(id, cb, params)),
    logisticRejection: (id, cb, params) =>
      dispatch(DashboardAction.logisticsRejectionReq(id, cb, params)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LogisticsContainer);
